import { ResetFilterButton } from '@components/ui/button';
import { TextSearchFilter } from '@components/ui/search-filter';

import { useUrlFilter } from '@/hooks';

export const ProductSectionFilters = () => {
    const { setSearchText, searchText } = useUrlFilter();

    return (
        <div className={'flex flex-wrap items-center gap-4'}>
            <TextSearchFilter
                placeholder={'name'}
                onChangeSearch={(e) => {
                    setSearchText(e.target.value);
                }}
                value={searchText}
            />
            <ResetFilterButton />
        </div>
    );
};

ProductSectionFilters.displayName = 'ProductSectionFilters';
